import { createModule } from '@nextiva/analytics-lib';
var stateSelector = createModule({
  storeKey: 'featureToggle'
}).stateSelector;
export { stateSelector };